import { css } from '@emotion/react'
import Markdown from 'markdown-to-jsx'
import { colors, font, mq } from 'plume-ui'
import { ReactNode } from 'react'

type Props = {
  className?: string
  children?: React.ReactNode
}

export const TouMarkdown: React.FC<Props> = (props) => {
  return (
    <Markdown
      className={props.className}
      css={css`
        h2 {
          font-size: 28px;
          font-weight: ${font.weight.bold};
          text-align: center;
          line-height: 1.5;
          letter-spacing: 0.01em;
          margin: 0;
          ${mq.untilMedium} {
            font-size: 20px;
          }
        }

        h3 {
          font-size: 20px;
          font-weight: ${font.weight.bold};
          line-height: 1.5;
          letter-spacing: 0.02em;
          margin: 56px 0 0 0;
          ${mq.untilMedium} {
            font-size: 18px;
            margin: 40px 0 0 0;
          }
        }

        h6 {
          font-size: 16px;
          line-height: 2;
          letter-spacing: 0.02em;
          font-weight: ${font.weight.normal};
          margin: 56px 0 0 0;
        }

        p {
          font-size: 16px;
          line-height: 2;
          letter-spacing: 0.02em;
          margin: 24px 0 0 0;
          ${mq.untilMedium} {
            font-size: 15px;
            line-height: 1.75;
            margin: 15px 0 0 0;
          }
        }

        a {
          color: ${colors.link};
          :hover {
            text-decoration: underline;
          }
        }

        blockquote {
          display: flex;
          justify-content: flex-end;
          margin: 56px 0 0 0;
        }

        ol {
          padding: 0 0 0 1.7rem;
          ${mq.untilMedium} {
            padding: 0 0 0 1.7rem;
          }
          ol {
            margin-top: 16px;
            padding: 0 0 0 2.5rem;
          }
        }

        li {
          font-size: 16px;
          letter-spacing: 0.02em;
          line-height: 2;
          ${mq.untilMedium} {
            font-size: 15px;
            line-height: 1.75;
          }
        }

        ol li {
          margin-bottom: 16px;
          position: relative;
          counter-increment: number;
          list-style: none;
          ::before {
            position: absolute;
            top: 0;
            left: 0;
            content: counter(number) '.';
            transform: translateX(-170%);
          }
          :nth-of-type(n + 10) {
            ::before {
              left: 1em;
            }
          }
        }

        ol ol li {
          position: relative;
          list-style: none;
          counter-increment: list-in-list-count;
          ::before {
            position: absolute;
            top: 0;
            left: 0;
            content: '(' counter(list-in-list-count) ')';
            transform: translateX(-170%);
          }
          :nth-of-type(n + 10) {
            ::before {
              left: 1em;
            }
          }
        }
      `}
      options={{
        overrides: {
          a: {
            component: anchorTarget,
          },
        },
      }}
    >
      {props.children}
    </Markdown>
  )
}

const anchorTarget = (props: {
  href: string
  title?: string
  children: ReactNode
}) => {
  const target =
    -1 < props.href.search(/newspicks\.com|\.pdf/) ? '_blank' : '_top'
  return (
    <a href={props.href} title={props.title} target={target}>
      {props.children}
    </a>
  )
}
